import { useCallback, useState } from "react";
import { useDebouncedCallback } from "use-debounce";

export function useSearchState(initialValue: string) {
  const [inputValue, setInputValue] = useState(initialValue);
  const [search, setSearch] = useState(initialValue);

  const debouncedSetSearch = useDebouncedCallback(setSearch, 500);

  const handleSearch = useCallback((value: string) => {
    debouncedSetSearch.cancel();
    setInputValue(value);
    debouncedSetSearch(value);
  }, [debouncedSetSearch]);

  return {
    inputValue,
    search,
    onSearch: handleSearch,
  };
}
